export { default as detailBookMarkConfig } from "./detail-bookmark-config";
export { default as detailCommentConfig } from "./detail-comment-config";
export { default as detailShareConfig } from "./detail-share-config";
export { default as detailCategoriesConfig } from "./detail-categories-config";
export { default as detailVideosConfig } from "./detail-videos-config";
export { default as detailReportConfig } from "./detail-report-config";
